import React from 'react';

import { Spin, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { useLocalSelector } from '@app/services/hooks/useRedux';
import { selectIsCounterpartySpace } from '@app/store/currentSessionReducer';

import { useCounterpartyOrderRedirectQuery, useOrderRedirectQuery } from './hooks';

interface IProps {
  orderUid: string;
}

export const OrderLink: React.FC<IProps> = ({ orderUid }) => {
  const documentsT = useTranslation(NSKeys.warehouseDocuments);
  const isCounterparty = useLocalSelector(selectIsCounterpartySpace);
  const clientRedirect = useOrderRedirectQuery(orderUid);
  const counterpartyRedirect = useCounterpartyOrderRedirectQuery(orderUid);
  const isLoading = isCounterparty ? counterpartyRedirect.isLoading : clientRedirect.isLoading;
  const redirect = () => (isCounterparty ? counterpartyRedirect.mutate() : clientRedirect.mutate());

  return (
    <Typography.Link
      ellipsis
      disabled={isLoading}
      style={{ display: 'block', width: '100%' }}
      onClick={(event) => {
        event.stopPropagation();
        if (!isLoading) {
          redirect();
        }
      }}>
      {isLoading && <Spin size="small" style={{ marginRight: 8 }} />}
      {documentsT.t('order.link')}
    </Typography.Link>
  );
};
